import { UserDataDto } from '../interfaces/user-data.interface';

export class UserData {
  public static fromDto(userData: UserDataDto): UserData {
    return new UserData(userData.key, userData.value);
  }

  constructor(public key: string, public value: any) {}
}
